import { render, staticRenderFns } from "./BaseInfo.vue?vue&type=template&id=67efd1bc&scoped=true"
import script from "./BaseInfo.vue?vue&type=script&lang=js"
export * from "./BaseInfo.vue?vue&type=script&lang=js"
import style0 from "./BaseInfo.vue?vue&type=style&index=0&id=67efd1bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67efd1bc",
  null
  
)

export default component.exports